import React from 'react';
import Menu from '../Screens/Menu.js';
import '../assets/css/Order.css';
import { withStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid'
import Form from '../components/Form/AddProductForm'


const useStyles = theme => ({
    root: {
        '& > *': {
            margin: theme.spacing(1),
            marginBottom: theme.spacing(10)
        }
    },
    back: {
        color: 'red',
        marginTop: '30%'
    },
});

class AddProduct extends React.Component {
    
    navigateBack = () => {
        this.props.history.goBack()
    }

    render() {
        return (
            <div style={{ backgroundColor: 'white', height: '100vh' }}>
                <Grid container>
                    <Grid item>
                        <div>
                            <Menu />
                        </div>
                    </Grid>
                </Grid>
                <div className="mdata">
                    <Form 
                        lenderId={this.props.match.params.lenderId} 
                        navigateBack={this.navigateBack} 
                        lenderName={this.props.location.state.lender_name} 
                    />
                </div>
            </div>
        );
    }

}

export default withStyles(useStyles, { withTheme: true })(AddProduct)